module.exports = __webpack_public_path__ + "img/header.f8074f48.png";